const PieChart = () => {
    return (
      <div className="self-stretch h-[260px] relative bg-blue overflow-hidden shrink-0" />
    );
  };
  
  export default PieChart;  